<template>
  <b-container fluid>
    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModal"
      title="Import Data"
      ok-title="Submit"
      :loading="loadingImport"
      @ok="handleImport"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i class="fa fa-times cursor-pointer" @click="showModal = false"></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          v-if="!loadingExportTemplate"
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExportTemplate"
        >
          <i class="fa fa-download"></i>
          Download Template
        </b-button>
        <b-button v-else variant="outline-primary" class="mt-3 w-100">
          <b-spinner style="width: 18px; height: 18px" class="mr-2"></b-spinner>
          Downloading
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->

    <!-- Modal Info Repoonse Import -->
    <b-modal
      v-model="modalResponseImport"
      title="Import Result"
      size="xl"
      hide-footer
    >
      <ImportResultRh :response="dataResponseImport" />
    </b-modal>

    <!-- Modal Remarks -->
    <b-modal v-model="showModalRemarks" title="Remarks" size="lg" hide-footer>
      <div class="p-3">
        <p class="text-black">{{ selectedRemarks }}</p>
      </div>
    </b-modal>

    <!-- SIDEBAR -->
    <custom-sidebar
      v-model="showCanvas"
      size="xl"
      :title="selectedData ? 'Detail Adjustment GOH' : 'Add Adjustment GOH'"
    >
      <div class="p-4 bg-white shadow-sm" style="border-radius: 10px">
        <FormGoh
          v-if="showCanvas"
          :selectedData="selectedData"
          @refetch="
            () => {
              fetchData()
              showCanvas = false
            }
          "
          @close="showCanvas = false"
        />
      </div>
    </custom-sidebar>

    <iq-card>
      <template #headerTitle>
        <h5 class="card-title text-primary">
          <strong>ADJUSTMENT KICK OFF GOH</strong>
        </h5>
      </template>
      <template #body>
        <b-row>
          <FilterRh :filters="filters" />
          <b-col lg="6" class="d-flex justify-content-end">
            <!-- <b-button
              variant="outline-primary"
              style="height: max-content"
              class="d-flex align-items-center"
              @click="handleExport()"
              :disabled="loadingExport"
            >
              <template v-if="!loadingExport">
                <i class="ri-upload-2-line pl-1"></i>
                Export
              </template>
              <template v-else>
                <b-spinner small class="mr-2"></b-spinner>
                Exporting...
              </template>
            </b-button> -->
            <b-button
              variant="outline-primary"
              class="d-flex align-items-center mx-2"
              style="height: max-content"
              @click="showModal = true"
            >
              <i class="ri-download-2-line pl-1"></i>
              Import
            </b-button>
            <b-button
              variant="primary"
              style="height: max-content"
              @click="
                showCanvas = true
                selectedData = null
              "
            >
              Create Adjustment Kick Off GOH
            </b-button>
          </b-col>
          <template v-if="!loading">
            <b-col md="12" v-if="rhData.data?.length">
              <div class="overflow-auto" style="position: relative">
                <table class="w-100 table-striped table-hover">
                  <thead>
                    <tr>
                      <th style="min-width: 20%">FLEET NAME</th>
                      <th style="min-width: 40%">ENGINE NAME</th>
                      <th style="min-width: 20%">EFFECTIVE DATE</th>
                      <th style="min-width: 20%">KICK OFF GOH</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, itemIndex) in rhData.data">
                      <tr
                        v-for="(power, powerIndex) in item.powers"
                        :key="`${item.id}-${power.id}`"
                        :class="{
                          'border-bottom-yellow':
                            powerIndex === item.powers.length - 1,
                        }"
                      >
                        <!-- Fleet Column (rowspan for first power) -->
                        <td
                          v-if="powerIndex === 0"
                          :rowspan="item.powers.length"
                          class="align-middle bg-white border-right-light"
                        >
                          <div class="mb-2">
                            <b-button
                              variant="success"
                              size="sm"
                              class="text-truncate w-100"
                            >
                              {{ item.vehicle_name || '-' }}
                            </b-button>
                          </div>
                          <b-dropdown
                            size="sm"
                            variant="outline-primary"
                            text="Action"
                            class="w-100"
                            right
                          >
                            <b-dropdown-item @click="handleDetail(item)">
                              <i class="fa fa-eye mr-2"></i>
                              Detail
                            </b-dropdown-item>
                            <b-dropdown-item
                              @click="handleDelete(item)"
                              class="text-danger"
                            >
                              <i class="fa fa-trash-alt text-danger mr-2"></i>
                              Delete
                            </b-dropdown-item>
                          </b-dropdown>
                        </td>

                        <!-- Engine Name Column -->
                        <td>
                          <div class="font-weight-bold">
                            {{ power.power_type }}
                          </div>
                          <div class="text-muted small">
                            {{ power.power_series_detail?.name }} -
                            {{ power.power_series_detail?.model }}
                          </div>
                        </td>

                        <!-- Effective Date Column -->
                        <td>
                          {{ formatDate(power.effective_date) }}
                        </td>

                        <!-- Kick Off GOH Column -->
                        <td>{{ formatNumber(power.kick_off_goh) }} Hours</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div
                class="mt-4 d-flex align-items-center w-100 justify-content-between"
              >
                <p class="mb-0">
                  Total Rows:
                  <strong class="text-black">{{ rhData.params.total }}</strong>
                </p>
                <div class="d-flex justify-content-end">
                  <b-pagination
                    class="mb-0 mr-3"
                    @change="
                      (page) => {
                        rhData.params.page = page
                        fetchData()
                      }
                    "
                    v-model="rhData.params.page"
                    :total-rows="rhData.params.total"
                    :per-page="rhData.params.limit"
                    first-number
                    align="center"
                  ></b-pagination>
                  <b-form-select
                    plain
                    v-model="rhData.params.limit"
                    :options="limitOptions"
                    style="width: 140px"
                    @input="fetchData"
                  ></b-form-select>
                </div>
              </div>
            </b-col>
          </template>
          <template v-else>
            <div
              class="w-100 d-flex justify-content-center align-items-center my-5 py-5"
            >
              <b-spinner></b-spinner>
            </div>
          </template>
          <template v-if="!rhData.data?.length && !loading">
            <b-col cols="12">No Data Here!</b-col>
          </template>
        </b-row>
      </template>
    </iq-card>
  </b-container>
</template>
<script>
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'
import FormRunningHours from './FormRunningHours.vue'
import moment from '@/node_modules/moment/moment'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import _ from 'lodash'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import RhAdjustmnetList from '../Components/RhAdjustmnetList.vue'
import ImportResultRh from './ImportResultRh.vue'
import FormGoh from './FormGoh.vue'
import FilterRh from './FilterRh.vue'

export default {
  components: {
    FormRunningHours,
    CustomSidebar,
    RhAdjustmnetList,
    ImportResultRh,
    FormGoh,
    FilterRh,
  },
  name: 'MainPageGOH',
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      selectedData: null,
      showModalFilter: false,
      modalResponseImport: false,
      dataResponseImport: null,
      showCanvas: false,
      runningHours: null,
      limitOptions: limitOptions,
      cellValue: null,
      showModal: false,
      loadingImport: false,
      loadingExport: false,
      loadingExportTemplate: false,
      importFile: null,
      showModalRemarks: false,
      selectedRemarks: '',
      rhData: {
        params: {
          search: this.$route.query.search || '',
          year: moment().format('YYYY'),
          month: moment().format('MM'),
          page: 1,
          limit: 10,
          totalPages: 1,
          total: 1,
        },
        data: [],
        detailData: null,
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    ...pmsActions,
    getPhotoSrc(data) {
      return data?.personal_data?.photo
        ? data?.personal_data?.photo_url
        : this.$getInitials(data?.detail?.name)
    },
    onPhotoError(evt, data) {
      if (!evt || !data) return
      evt.target.onerror = null
      evt.target.src = this.$getInitials(data?.detail?.name)
    },
    formatNumber(val) {
      if (val === null || val === undefined || val === '') return '-'
      const num = Number(val)
      if (!isFinite(num)) return val
      const sign = num < 0 ? '-' : ''
      const [intPart, decPart] = Math.abs(num).toString().split('.')
      const withDots = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return decPart ? `${sign}${withDots},${decPart}` : `${sign}${withDots}`
    },
    async handleExportTemplate() {
      try {
        this.loadingExportTemplate = true
        const params = {
          date: moment(this.date).format('YYYY-MM-DD'),
        }
        const res = await this.exportTemplateGOH(params)
        if (res?.status !== 'success') {
          throw new Error('Failed to download template')
        }
        saveAs(res.data, 'template_import_goh.xlsx')
        this.$swal({
          title: 'Download Template Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Download Template',
          icon: 'error',
        })
      } finally {
        this.loadingExportTemplate = false
      }
    },
    async handleExport() {
      try {
        this.loadingExport = true
        const year = moment(this.date).format('YYYY')
        const month = moment(this.date).format('MM')
        const params = {
          year,
          month,
        }
        const res = await this.exportRunningHoursV3(params)
        saveAs(res.data, `goh_${month}_${year}.xlsx`)
        this.$swal({
          title: 'Export Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Export Data',
          icon: 'error',
        })
      } finally {
        this.loadingExport = false
      }
    },
    async handleImport() {
      try {
        this.loadingImport = this.msgErrImport = []
        const formData = new FormData()
        formData.append('file', this.importFile)
        const res = await this.importGOH(formData)
        console.log(res)
        this.dataResponseImport = res.data.data
        this.modalResponseImport = true
        // this.$swal({
        //   title: 'Import Data Success',
        //   icon: 'success',
        // })
      } catch (error) {
        this.$swal({
          title: 'Failed Import Data!',
          type: 'error',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
          // didClose: () => {
          //   this.showErrImport = true
          // },
        })
      } finally {
        this.loadingImport = false
        this.fetchData()
      }
    },
    formatDate(date) {
      return date ? moment(date).format('DD MMM YYYY') : '-'
    },
    handleShowRemarks(remarks) {
      this.selectedRemarks = remarks
      this.showModalRemarks = true
    },
    async fetchData(loadValue = true) {
      this.loading = loadValue
      const params = {
        limit: this.rhData.params.limit,
        page: this.rhData.params.page,
        year: moment(this.filters.month).format('YYYY'),
        month: moment(this.filters.month).format('MM'),
      }
      // Handle multiple vehicle selection
      if (
        this.filters.vehicle &&
        Array.isArray(this.filters.vehicle) &&
        this.filters.vehicle.length > 0
      ) {
        const vehicleIds = this.filters.vehicle.map((v) => v.id).join(',')
        params.vehicle_id = vehicleIds
      } else {
        delete params.vehicle_id
      }
      const res = await this.getGOH(params)
      if (res?.status === 'success') {
        const { data } = res
        this.rhData.data = data.data
        this.rhData.params.total =
          data?.meta?.total_item || data?.pagination?.total || 0
      } else {
        console.log(res)
      }
      this.loading = false
    },
    handleDetail(item) {
      this.selectedData = item
      this.showCanvas = true
    },
    handleDelete(item) {
      this.$swal({
        title: 'Delete GOH Data?',
        text: `This action will permanently delete GOH data for ${
          item.vehicle?.name || 'this vehicle'
        }.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const ids = item.powers.map((power) => power.id)
            const res = await Promise.all(
              ids.map((id) => this.deleteGOH({ id }))
            )
            if (res[0].status === 'success') {
              this.$swal('Deleted!', 'GOH data has been deleted.', 'success')
              this.fetchData()
            } else {
              this.$swal(
                'Error',
                res[0]?.data?.message || 'Failed to delete GOH data',
                'error'
              )
            }
          } catch (error) {
            this.$swal('Error', 'An error occurred', 'error')
          }
        }
      })
    },
  },
  watch: {
    filters: {
      handler() {
        this.fetchData()
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
table th {
  padding: 8px 12px;
}
table td {
  padding: 8px 12px;
  color: black;
}
tr.border-bottom-yellow {
  border-bottom: 3px solid #ffc107;
}
td.border-right-light {
  border-right: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
}
</style>
